<template>
	<div>
		<hr/>
	</div>
</template>

<script>

export default{
	name: "HBreak"
}
</script>


<style scoped>

@font-face { font-family: "Roboto Condensed"; src: url("https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-19K7DQ.woff2") format("woff2"); font-style: normal; font-weight: 400; unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }

div {
	padding-bottom: 25px;
	padding-top: 25px;
	margin-left: auto;
	margin-right: auto;
	max-width: 370px;
	width: 90vw;

}

hr {

	border: 0;
	border-top-width: 1px;
	border-top-style: solid;
	border-top-color: #8f8e8e;
}

</style>